import { SessionStorageService } from '@mwe/utils';
import { MemoryCacheItem, MemoryCacheService } from '../cache/memory-cache.service';
import { inject } from '@angular/core';

export abstract class ConfirmationStatusStateService {
  readonly memoryCacheService = inject(MemoryCacheService);

  protected constructor(
    protected storage: SessionStorageService,
    protected lastOrderIdKey: string,
    protected retriedOnErrorKey: string,
    protected submitIdKey: string,
    public memoryCacheItem?: MemoryCacheItem,
  ) {}

  abstract clearAll(): void;

  clear(): void {
    this.storage.clear(this.lastOrderIdKey);
    this.storage.clear(this.retriedOnErrorKey);
    this.storage.clear(this.submitIdKey);

    if (this.memoryCacheItem) {
      this.memoryCacheService.clear(this.memoryCacheItem);
    }
  }

  get submitId(): number {
    return this.storage.getItem(this.submitIdKey) || undefined;
  }

  set submitId(submitId: number) {
    if (submitId) {
      this.storage.setItem(this.submitIdKey, submitId);
    } else {
      this.storage.clear(this.submitIdKey);
    }
  }

  get lastOrderId(): string {
    return this.storage.getItem(this.lastOrderIdKey) || undefined;
  }

  set lastOrderId(lastOrderId: string) {
    if (lastOrderId) {
      this.storage.setItem(this.lastOrderIdKey, lastOrderId);
    } else {
      this.storage.clear(this.lastOrderIdKey);
    }
  }

  get retriedOnError(): boolean {
    return this.storage.getItem(this.retriedOnErrorKey) || undefined;
  }

  set retriedOnError(retriedOnError: boolean) {
    if (retriedOnError) {
      this.storage.setItem(this.retriedOnErrorKey, retriedOnError);
    } else {
      this.storage.clear(this.retriedOnErrorKey);
    }
  }
}
